var map = {
	"./NFC-ideas-preferences.jpg": "5fbb",
	"./No.png": "0bbb",
	"./Not-Sure.png": "4505",
	"./Yes.png": "4a8c",
	"./apple.png": "b704",
	"./beep.gif": "02b1",
	"./celebration.gif": "ff7e",
	"./companion-sys-tray.jpg": "20a6",
	"./logo.png": "013a",
	"./nobeep.gif": "7225",
	"./support.jpg": "f4f8",
	"./windows.jpg": "9450"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";